import { render, staticRenderFns } from "./BusesBook.vue?vue&type=template&id=321c913c&"
import script from "./BusesBook.vue?vue&type=script&lang=js&"
export * from "./BusesBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports